export default __webpack_public_path__ + "static/media/master-card.e1532df1.svg";